import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import vco from 'v-click-outside'

import VueI18Next from '@panter/vue-i18next'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18next from '@/utils/i18next'
import VueCookies from 'vue-cookies'
import VueLazyLoad from 'vue-lazyload'

Vue.config.productionTip = false

Vue.use(VueLazyLoad)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(VueI18Next)
Vue.use(VueCookies)

const i18n = new VueI18Next(i18next)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
